import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { Shield, FileText, Map, Smartphone } from 'lucide-react';
import { DemoCard } from './components/DemoCard';
const DEMOS = [{
  title: 'Public Health Portal',
  description: "See what your county's website could look like with DineSafe built in — fully branded, with food safety reporting ready for citizens from day one.",
  icon: <Shield className="w-6 h-6" data-id="element-0" />,
  url: 'https://franklincounty.dinesafe.com'
}, {
  title: 'Food Poisoning Report Form',
  description: "The form your residents use to report foodborne illness. Every submission feeds directly into DineSafe's outbreak detection engine.",
  icon: <FileText className="w-6 h-6" data-id="element-1" />,
  url: 'https://widgets.dinesafe.com'
}, {
  title: 'Inspections Map',
  description: 'Give residents a public-facing map to search restaurant inspections by location — transparency that builds trust.',
  icon: <Map className="w-6 h-6" data-id="element-2" />,
  url: 'https://inspections-map.dinesafe.com'
}, {
  title: 'Inspections App',
  description: 'Real inspection data from Florida in a fast, mobile-ready interface. Built for inspectors in the field and citizens on the go.',
  icon: <Smartphone className="w-6 h-6" data-id="element-3" />,
  url: 'https://inspections.dinesafe.com'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
export function App() {
  useEffect(() => {
    document.title = 'DineSafe — Demo Hub';
  }, []);
  return <div className="min-h-screen bg-dinesafe-bg bg-pattern relative overflow-hidden flex flex-col" data-id="element-4">
      {/* Subtle ambient glow */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-dinesafe-accent/5 blur-[120px] pointer-events-none" data-id="element-5" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-[#3b2d63]/20 blur-[120px] pointer-events-none" data-id="element-6" />

      <div className="max-w-5xl mx-auto px-6 py-12 md:py-20 flex-grow w-full flex flex-col relative z-10" data-id="element-7">
        {/* Header */}
        <motion.header className="text-center mb-16 md:mb-24" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-9">
            DineSafe
          </h2>
          <p className="text-lg md:text-xl text-dinesafe-muted max-w-2xl mx-auto" data-id="element-10">
            Food Safety Solutions for Public Health
          </p>
          <p className="text-sm text-dinesafe-muted/70 max-w-xl mx-auto mt-3" data-id="element-11">
            This is a live demo environment. Feel free to submit test reports —
            no data is sent to any health department.
          </p>
        </motion.header>

        {/* Grid */}
        <motion.main className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto w-full" variants={containerVariants} initial="hidden" animate="visible" data-id="element-12">
          {DEMOS.map((demo, index) => <DemoCard key={index} title={demo.title} description={demo.description} icon={demo.icon} url={demo.url} data-id="element-13" />)}
        </motion.main>
      </div>

      {/* Footer */}
      <motion.footer className="py-8 text-center text-sm text-dinesafe-muted relative z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.8
    }} data-id="element-14">
        <p data-id="element-15">Powered by DineSafe &middot; iwaspoisoned.com</p>
      </motion.footer>
    </div>;
}